<template>
  <section class="space-y-6">
    <div
      v-if="selectedParameter.param_data && status == 'STOPPED'"
      class="divide-y divide-ontick-steel-300 rounded border border-ontick-steel-300 p-3 dark:divide-ontick-steel-500 dark:border-ontick-steel-800 sm:divide-y-0"
    >
      <div class="row" v-if="strategy.strategy_market === 'Equities'">
        <p class="text-medium text-sm text-ontick-steel-900 dark:text-gray-300">
          <span v-if="strategy.volume_type === 'FIN_VOLUME'"
            >Volume financeiro</span
          >
          <span v-if="strategy.volume_type === 'QUANTITY'"
            >Quantidade de ações</span
          >
        </p>
        <template v-if="selectedParameter.param_data">
          <p v-if="strategy.strategy_market === 'Equities'">
            <span v-if="strategy.volume_type === 'FIN_VOLUME'">
              {{ volume | currency }}
            </span>
            <span v-if="strategy.volume_type === 'QUANTITY'">
              {{ volume }}
            </span>
          </p>
        </template>
      </div>

      <div v-else class="row">
        <p class="text-medium text-sm text-ontick-steel-900 dark:text-gray-300">
          Contratos
        </p>
        <template v-if="selectedParameter.param_data">
          <p>
            {{ volume }}
          </p>
        </template>
      </div>

      <div class="row">
        <p class="text-medium text-sm text-ontick-steel-900 dark:text-gray-300">
          Perda máxima
        </p>
        <p v-if="volumeIsLoading">
          <i v-html="$icons.loading" class="text-ontick-blue-600"></i>
          <span class="sr-only">Carregando</span>
        </p>
        <template v-else-if="selectedParameter.param_data">
          <p class="text-ontick-red-600" v-if="maxLoss !== 0">
            {{ maxLoss | currency }}
          </p>
          <p class="text-ontick-red-600" v-else>N/D</p>
        </template>
      </div>

      <div class="row">
        <p class="text-medium text-sm text-ontick-steel-900 dark:text-gray-300">
          Ganho máximo
        </p>
        <p v-if="volumeIsLoading">
          <i v-html="$icons.loading" class="text-ontick-blue-600"></i>
          <span class="sr-only">Carregando</span>
        </p>
        <template v-else-if="selectedParameter.param_data">
          <p class="text-ontick-green-600" v-if="maxGain !== 0">
            {{ maxGain | currency }}
          </p>
          <p class="text-ontick-green-600" v-else>N/D</p>
        </template>
      </div>

      <div class="row" v-if="recommendedCapital !== Infinity">
        <p
          class="text-medium text-sm text-ontick-steel-900 dark:text-gray-300"
          v-if="strategy.strategy_market !== 'Equities'"
        >
          Capital recomendado
        </p>
        <p
          v-if="
            strategy.strategy_market !== 'Equities' &&
            selectedParameter.param_data
          "
        >
          {{ recommendedCapital | currency }}
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    selectedParameterInvestment: { type: Object },
    selectedParameter: { type: Object },
    status: { type: String },
    strategy: { type: Object },
  },

  data() {
    return {
      financialVolume: 0,
      volumeIsLoading: false,
    };
  },

  computed: {
    volume() {
      return this.selectedParameterInvestment.value;
    },
    maxLoss() {
      if (this.strategy.strategy_market === "Equities") {
        return this.strategy.max_loss;
      } else {
        return parseInt(this.selectedParameter.param_data.fin_sl);
      }
    },
    maxGain() {
      if (this.strategy.strategy_market === "Equities") {
        return this.strategy.max_gain;
      } else {
        return parseInt(this.selectedParameter.param_data.fin_tp);
      }
    },
    recommendedCapital() {
      return (
        this.volume *
        (this.selectedParameterInvestment.item.min_capital /
          this.selectedParameterInvestment.item.volume_step)
      );
    },
  },

  methods: {
    GET_VOLUME_CHECK(val) {
      if (this.strategy.strategy_market === "Equities") {
        this.volumeIsLoading = true;
        this.$api
          .post(this.$endpoint.CHECK_VOLUME, {
            symbol: this.strategy.strategy_symbol,
            volume_type: this.strategy.volume_type,
            typed_volume: val,
          })
          .then(({ data }) => {
            this.financialVolume = data.fin_volume;
          })
          .catch((err) => {
            console.error(err?.data?.msg);
            // if (
            //   err.data.msg ==
            //     "Quantidade inferior ao lote mínimo para o ativo" ||
            //   err.data.msg == "Financeiro inferior ao valor mínimo para o ativo"
            // ) {
            //   manageVolume(this.isFinancialVolume, err.data, true);
            // }
          })
          .finally(() => {
            this.volumeIsLoading = false;
          });
      }
    },
  },

  created() {
    this.GET_VOLUME_CHECK(this.strategy.curr_volume);
  },
};
</script>

<style lang="scss" scoped>
.row {
  @apply grid grid-cols-2 gap-6 py-2 sm:py-0;
}
</style>
